import React, { createContext, useContext, useReducer } from "react";

const DataContext = createContext(null);

const intialState = {
  birthYear: null,
  gender: null,
  education: null,
  country: null,
  games: null,
  result: null,
  allresult: {},
  id: null,
  suggestion: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "updateBirthYear":
      return { ...state, birthYear: action.payload };
    case "updateGender":
      return { ...state, gender: action.payload };
    case "updateEducation":
      return { ...state, education: action.payload };
    case "updateCountry":
      return { ...state, country: action.payload };
    case "updateId":
      return { ...state, id: action.payload };
    case "updateResult":
      return { ...state, result: action.payload };
    case "updateSuggestion":
      return { ...state, suggestion: action.payload };
    case "updateAllResult":
      return {
        ...state,
        allresult: {
          ...state.allresult,
          ...action.payload, 
        },
      };
    case "reset":
      return intialState;
    default:
      throw new Error("unknown action");
  }
}

function DataContextProvider({ children }) {
  const [
    {
      birthYear,
      gender,
      education,
      country,
      result,
      id,
      suggestion,
      allresult,
    },
    dispatch,
  ] = useReducer(reducer, intialState);
  function updateYear(year) {
    dispatch({ type: "updateBirthYear", payload: year });
  }
  function updateGender(gender) {
    dispatch({ type: "updateGender", payload: gender });
  }
  function updateEducation(edu) {
    dispatch({ type: "updateEducation", payload: edu });
  }
  function updateCountry(country) {
    dispatch({ type: "updateCountry", payload: country });
  }
  function updateId(id) {
    dispatch({ type: "updateId", payload: id });
  }
  function updateResult(result) {
    dispatch({ type: "updateResult", payload: result });
  }
  function updateAllResult(allresult) {
    dispatch({ type: "updateAllResult", payload: allresult });
  }
  function updateSuggestion(suggestion) {
    dispatch({ type: "updateSuggestion", payload: suggestion });
  }
  function clearDataGame() {
    dispatch({ type: "reset" });
  }

  return (
    <DataContext.Provider
      value={{
        birthYear,
        gender,
        education,
        country,
        result,
        id,
        suggestion,
        allresult,
        updateCountry,
        updateEducation,
        updateGender,
        updateYear,
        updateId,
        updateResult,
        updateSuggestion,
        clearDataGame,
        updateAllResult,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const context = useContext(DataContext);
  return context;
}

export default DataContextProvider;
